<div>

    <app-loader *ngIf="!isDataReady"></app-loader>
    <div class="ui-g" *ngIf="isDataReady">

        <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
            <div class="ui-g-3 ui-sm-5 ">
                <span class="ui-float-label">
                    <p-calendar dateFormat="dd.mm.yy" [(ngModel)]="model.dateFrom" [style]="{'width':'100%'}"
                        [inputStyle]="{'width':'100%'}"></p-calendar>
                    <label for="float-input">{{'date_from' | translate}}</label>
                </span>
            </div>
            <div class="ui-g-3 ui-sm-5 ">
                <span class="ui-float-label">
                    <p-calendar dateFormat="dd.mm.yy" [(ngModel)]="model.dateTo" [style]="{'width':'100%'}"
                        [inputStyle]="{'width':'100%'}"></p-calendar>
                    <label for="float-input">{{'date_to' | translate}}</label>
                </span>
            </div>



            <div class="ui-g-3 ui-sm-5 ">
                <button pButton type="button" label="Filtruj" (click)="this.onFilter()"></button>
            </div>
        </div>

        <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12" *ngIf="isAdmin">
            <div class="ui-g-3 ui-sm-5 ">
                <p-checkbox [label]="'Opłacone'" [binary]="true" [(ngModel)]="model.isPaid"></p-checkbox>
            </div>
        </div>

        <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">


            <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <p-panel [style]="{'color':'#333333', 'background-color':'#f4f4f4', 'margin-bottom': '20px'}"
                    *ngFor="let order of orders">
                    <p-header>
                        <div class="ui-helper-clearfix">
                            <div class="order">

                                <div>
                                    <span class="ui-panel-title">
                                        {{ 'order_no' | translate }}: {{ order.id }}
                                    </span>
                                </div>


                            </div>

                        </div>
                    </p-header>

                    <div class="p-grid">
                        <div class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
                            <div *ngFor="let item of order.items; index as i">
                                <div>



                                    <div class="p-grid">
                                        <div class="orderItem p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
                                            <span class="orderItemTitle">{{ i+1 }}. {{ item.title }} {{item.price |
                                                currencyReduce:true | currency: order.currency_histories.currency_code
                                                }}</span>
                                        </div>


                                    </div>



                                </div>
                            </div>


                        </div>

                    </div>

                    <div class="orderFooterLine"></div>

                    <div class="p-grid">
                        <div class="p-col-6 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                            <div style="display: block;">
                                <span>{{ 'order_date' | translate }}: {{ order.created_at | date:'dd.MM.yyyy, HH:mm:ss' }}</span><br/>
                                <span>{{ 'payment_date' | translate }}: {{ order.payment_date | date:'dd.MM.yyyy, HH:mm:ss' }}</span>
                            </div>
                        </div>

                        <div class="p-col-6 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                            <div style="display: flex;justify-content: flex-end;">
                                <span>Suma: {{order.items | orderTotal | currencyReduce:true | currency:
                                    order.currency_histories.currency_code }}</span>
                            </div>
                        </div>
                    </div>
                </p-panel>
            </div>


            <div *ngIf="orders.length == 0" class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
                <p-panel>
                    <div style="display: flex;justify-content: center;">
                        {{'orders_empty_orders' | translate}}
                    </div>
                </p-panel>

            </div>

        </div>


    </div>


</div>
<p-paginator *ngIf="isDataReady && orders.length != 0" [rows]="this.limit" [totalRecords]="this.totalCount"
    (onPageChange)="onPaginate($event)"></p-paginator>